enum UserBookmarkCountSortOption {
    BookmarkCreatedOnAscending = 0,
    BookmarkCreatedOnDescending = 1,
    BookOrder = 2,
    Collection = 3,
}

export default UserBookmarkCountSortOption;
